// AgreementSignDialog.tsx — подпись пользовательского соглашения квалифицированной ЭЦП.
// План docs/plans/2026-07-31-agreement-versioning-v2.md, Этап 4.
//
// Механика диалога — в общем EsignDialog. Здесь только специфика сценария: вызов
// POST Agreement/Accept и признак успеха по телу ответа.
import { useTranslation } from "react-i18next";
import EsignDialog, { EsignCredentials } from "./EsignDialog";
import { acceptAgreement } from "api/Agreement";

interface AgreementSignDialogProps {
  open: boolean;
  /** id активной редакции из Agreement/GetActive. */
  versionId: number;
  /** ИНН подписанта-физлица, подставляемый в поле при открытии. */
  defaultPin?: string;
  /**
   * ИНН организации. Задаётся, когда подпись идёт от юрлица: включает режим «юрлицо» и
   * подставляется в поле организации, а поле подписанта остаётся пустым — ЭЦП выдаётся
   * человеку, и туда вводится ЛИЧНЫЙ ИНН. Подставлять сюда ИНН компании нельзя: боевой CDS
   * вернёт personIdnp директора, и сверка в Accept отклонит подпись (CDS_PIN_MISMATCH).
   */
  defaultCompanyPin?: string;
  /**
   * Контакты заказчика для блока реквизитов в тексте соглашения. Передаются только с формы
   * регистрации: пользователя ещё нет в БД. В гейте не задаются — там подписывает залогиненный
   * пользователь, и сервер берёт контакты из его учётной записи.
   */
  customerEmail?: string;
  customerPhone?: string;
  onSigned: (acceptanceId: number, pin: string) => void;
  onClose: () => void;
  cancelLabel?: string;
}

const AgreementSignDialog = (props: AgreementSignDialogProps) => {
  const { t } = useTranslation();

  return (
    <EsignDialog
      open={props.open}
      id="AgreementSignDialog"
      title={t("label:digitalSign.enterYourInn")}
      defaultPin={props.defaultPin}
      defaultCompanyPin={props.defaultCompanyPin}
      cancelLabel={props.cancelLabel}
      successMessage={t("label:digitalSign.successfullySigned")}
      sign={(c: EsignCredentials) =>
        acceptAgreement(props.versionId, c.pin, c.code, c.pinOrganization, {
          email: props.customerEmail,
          phone: props.customerPhone,
        })
      }
      // Успех определяется телом: без acceptance_id акцепта не создалось, подписи нет.
      isSigned={(response) =>
        (response?.status === 200 || response?.status === 201) &&
        Boolean(response?.data?.acceptance_id)
      }
      onSigned={(response, pin) => props.onSigned(response.data.acceptance_id, pin)}
      onClose={props.onClose}
    />
  );
};

export default AgreementSignDialog;
